module.exports = __webpack_public_path__ + "img/join.b26be2ae.png";